module.exports = __webpack_public_path__ + "static/media/Power_.cb1acdab.png";